"use client";

import "./UiUxImpactSection.scss";

import { Container } from "react-bootstrap";
import Image from "next/image";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const UiUxImpactSection = ({ impact }) => {
  const { title, description, cases = [] } = impact;

  return (
    <section className="uiux-section">
      <Container fluid>
        <h2 className="uiux-title">{title}</h2>

        <p className="uiux-description">
          {description}
        </p>

        <div className="uiux-logo-wrapper">
          <Swiper
            modules={[Autoplay]}
            slidesPerView="auto"
            spaceBetween={40}
            loop={true}
            speed={3500}
            allowTouchMove={false}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
          >
            {[...cases, ...cases].map((item, index) => (
              <SwiperSlide key={index} className="uiux-logo-slide">
                <Image
                  src={item.image}
                  alt={item.title}
                  className="uiux-logo"
                  width={150}
                  height={80}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Container>
    </section>
  );
};

export default UiUxImpactSection;